export const getters = {
    getPortadorFinanceiro: state => state.portadorFinanceiro,
    getPortadoresFinanceiro: state => state.portadoresFinanceiro,
    getModalCadastroPortadorFinanceiro: state => state.modalCadastroPortadorFinanceiro,
    getModalExcluirPortadorFinanceiro: state => state.modalExcluirPortadorFinanceiro,
    getModalListarPortadorFinanceiro: state => state.modalListarPortadorFinanceiro,
}

export default {}